import {
  AlarmActionTypes,
  AlarmState
} from './alarm.types';

const initialState: AlarmState = {
  activeAlarms: [],
  suppressedAlarms: [],
  historicalAlarms: []
};

export default function alarmReducer(
  state = initialState,
  action: AlarmActionTypes
): AlarmState {
  switch (action.type) {
    default:
      return state;
  }
}
